import * as Sentry from '@sentry/react';

const SENTRY_DSN = 'https://038c45689644b8ccf93a4df1a26d6af1@o496919.ingest.us.sentry.io/4510774547578880';

// hostnameベースの環境判定
function getEnvironment(): string {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'dev';
  }

  if (hostname.startsWith('dev-') || hostname.includes('-dev')) {
    return 'dev';
  }

  if (hostname.startsWith('demo-') || hostname.includes('-demo')) {
    return 'demo';
  }

  return 'prod';
}

const environment = getEnvironment();
const isDevelopment = environment === 'dev';
const isProduction = environment === 'prod';
const isDemo = environment === 'demo';

declare const __BUILD_ID__: string;

export function initSentry(): void {
  // demo環境は無効
  if (isDemo) {
    console.info('Sentry is disabled for demo environment');
    return;
  }

  // 本番環境は常にON、開発環境はlocalStorageで制御
  const sentryEnabled = isProduction || localStorage.getItem('sentryEnabled') === 'true';

  if (!sentryEnabled) {
    console.info('Sentry is disabled for development environment');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment,

    // エラー監視のみ（パフォーマンス監視は無効）
    tracesSampleRate: 0,

    // リリース情報（ビルド時に生成されたID）
    release: `ver.${__BUILD_ID__}`,

    // エラーの前処理
    beforeSend(event) {
      // 開発環境ではコンソールにも出力
      if (isDevelopment) {
        console.error('Sentry error:', event);
      }
      return event;
    },

    // プライバシー設定
    sendDefaultPii: false,

    // 除外するエラー
    ignoreErrors: [
      // ネットワークエラーなど、アプリケーションのバグではないもの
      'Network Error',
      'NetworkError',
      'Failed to fetch',

      // ブラウザの拡張機能によるエラー
      'Non-Error promise rejection captured',
      'ResizeObserver loop limit exceeded',

      // PWA関連のエラー
      'ServiceWorker script evaluation failed',
      'Failed to register a ServiceWorker',

      // モバイルブラウザでよくあるエラー
      'Script error.',

      // 開発環境でよくあるエラー
      'ChunkLoadError',

      // Firebase Performance の MUI 関連エラー
      'Performance: Attribute value',
      'performance/invalid attribute value',

      // iOS Safari/WebKit の IndexedDB バグ（WebKit Bug #273827, #235579, #201483）
      'Connection to Indexed Database server lost',
    ],
  });

  console.info(`Sentry initialized for runport-nft (${environment})`);

  // dev環境ではコンソールからテストできるようにwindowに公開
  if (isDevelopment) {
    (window as unknown as { Sentry: typeof Sentry }).Sentry = Sentry;
  }
}

export { Sentry };
